function _isPrivate(property: string | number | symbol): boolean {
    return typeof property === "string" && property.startsWith("_");
}

export const publicProxyHandler: ProxyHandler<any> = {
    get: function(target, property) {
        if (!_isPrivate(property)) {
            const value = Reflect.get(target, property);
            return typeof value === "function" ? value.bind(target) : value;
        }
        return undefined;
    },
    set: function(target, property, value) {
        if (!_isPrivate(property)) {
            const desc = Reflect.getOwnPropertyDescriptor(target, property);
            if (desc && desc.writable)
                return Reflect.set(target, property, value);
        }
        return false;
    },
    has: function(target, property) {
        return _isPrivate(property) ? false : Reflect.has(target, property as string);
    },
    deleteProperty() {
        return false;
    },
    defineProperty() {
        return false;
    },
    // @ts-ignore Vyřešit v rámcu bugu https://tfs.tescosw.loc/Jadro/Jadro%20.NET/_workitems/edit/32276
    enumerate(target) {
        return Object.keys(target).filter((key) => !_isPrivate(key))[Symbol.iterator]() as any;
    },
    ownKeys(target) {
        return Reflect.ownKeys(target).filter((key) => !_isPrivate(key));
    },
    getOwnPropertyDescriptor: function(target, property) {
        return !_isPrivate(property) ? Reflect.getOwnPropertyDescriptor(target, property) : { configurable: false, enumerable: false, writable: false, value: undefined };
    },
};
